import { useDispatch, useSelector } from "react-redux"
import { changeStatus, onFetchclientAdress, selectClientAdressState } from "../redux/slices/clientAddressSlice"
import { ApiStatus } from "../types/api/status"
import { ClientAddressAPI } from "../apis/ClientAddressAPI"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"

export const useClientAddressStore = () => {
    const dispatch = useDispatch()
    const { clientAddresses, clientAddressesSelected, status, action } = useSelector(selectClientAdressState)

    const getClientAddresses = async (payload: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ClientAddressAPI.getClientAddress(payload)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(onFetchclientAdress(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createClientAddress = async (data: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ClientAddressAPI.create(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    return {
        clientAddresses,
        clientAddressesSelected,
        status,
        action,
        createClientAddress,
        getClientAddresses
    }
}